import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from '../../context/FormContext';
import Header from '../common/Header/Header';
import './SubmissionSuccess.css';

const SubmissionSuccess = () => {
  const { state } = useForm();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to home if not submitted
    if (!state.isSubmitted) {
      navigate('/');
    }
  }, [state.isSubmitted, navigate]);

  if (!state.isSubmitted) {
    return null;
  }

  const submissionDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  return (
    <div className="submission-success">
      <Header showMobileMenu={false} />
      <div className="container">
        <div className="success-content">
          <div className="success-icon">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          <h1>Application Submitted Successfully!</h1>

          <p className="success-message">
            Thank you for completing your pre-onboarding application. Your information has been received and is being reviewed by our team.
          </p>

          <div className="submission-details">
            <div className="detail-item">
              <span className="detail-label">Submission ID:</span>
              <span className="detail-value">{state.submissionId}</span>
            </div>

            <div className="detail-item">
              <span className="detail-label">Submitted on:</span>
              <span className="detail-value">{submissionDate}</span>
            </div>

          </div>

          <div className="next-steps">
            <h2>What happens next?</h2>
            <div className="steps-list">
              <div className="step-item">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h3>Review Process</h3>
                  <p>Our compliance team will review your application and documents.</p>
                </div>
              </div>

              <div className="step-item">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h3>Email Confirmation</h3>
                  <p>You will receive a confirmation email with your application details and next steps.</p>
                </div>
              </div>

              <div className="step-item">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h3>Follow-up Contact</h3>
                  <p>Our team will contact you if any additional information or clarification is needed.</p>
                </div>
              </div>

              <div className="step-item">
                <div className="step-number">4</div>
                <div className="step-content">
                  <h3>Onboarding Process</h3>
                  <p>Once approved, you will receive instructions to complete the full onboarding process.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmissionSuccess;
